<template>
  <div>
    <div class="title">
      <img :src="getTitleImage()" />
    </div>
    <div class="steps">
      <h1>{{ getText('goodbye_title') }}</h1>
      <p>{{ getText('goodbye_text') }}</p>
      <div class="ml-auto mr-auto mt-12 text-center">
        <button
          class="bg-white py-5 px-20 rounded-full"
          @click="start"
        >{{ getText('button_goto_start') }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  letter-spacing: 10px;
  line-height: 100%;
  text-align: center;
  font-size: 66px;
  margin-left: auto;
  margin-right: auto;
  text-transform: uppercase;
  width: 1100px;
}

p {
  font-family: FoundryWilsonNomal;
  font-size: 33px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 90px;
  width: 848px;
}

.title {
  margin-left: auto;
  margin-right: auto;
  margin-top: 54px;
  width: 490px;
  height: 320px;
}

.title img {
  width: 100%;
}
</style>

<script>
export default {
  name: "Goodbye",

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    getTitleImage: function() {
      return "images/jodler_" + this.$route.params.lang + ".svg";
    },

    async start() {
      this.$router.push({
        name: "home"
      });
    }
  },

  mounted() {
    this.Screenshot = window.finalPhoto;
  },

  data() {
    return {
      Screenshot: null
    };
  }
};
</script>